module.exports = __webpack_public_path__ + "f01cc06ed5b52a50e30bec543310a234.MP3";